var render, staticRenderFns
import script from "./CrtPatrolPoints.vue?vue&type=script&lang=js"
export * from "./CrtPatrolPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../shieldgo-admin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports